module.exports = __webpack_public_path__ + "static/media/m2.c58b6e72.jpg";